import React from 'react'

export default ({ children, className }) => (
  <main className={`main ${className}`}>{children}</main>
)
